import { meter } from '~shared/telemetry';

import { logger } from '~shared/logger';

import { createMakeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { createHttpRequestTracker } from '@breezeventures/web-ph-telemetry';

const httpRequestMeterTracker = createHttpRequestTracker(meter, [
  new RegExp('/auth/api/v1/merchant_authorizer/'),
]);

export const makeRequest = createMakeRequest({
  logger,
  loggerName: 'client-api',
  metricsTracker: httpRequestMeterTracker,
});
